import { render, staticRenderFns } from "./listApplyRoomDiscountRecordDetailsList.vue?vue&type=template&id=5c8f4c4c&scoped=true"
import script from "./listApplyRoomDiscountRecordDetailsList.vue?vue&type=script&lang=js"
export * from "./listApplyRoomDiscountRecordDetailsList.vue?vue&type=script&lang=js"
import style0 from "./listApplyRoomDiscountRecordDetailsList.vue?vue&type=style&index=0&id=5c8f4c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8f4c4c",
  null
  
)

export default component.exports